import React, { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
	fetchAdressesV2,
	fetchLocalites,
} from "../../../store/actions/adresseActions"
import FilteredSelectV2 from "../../basics/input/FilteredSelectV2"
import { generalStyles as gs } from "../../styles/styles"

// V2 editor for a single address. `update(key, value, whole)` mirrors the
// legacy contract: when `whole` is true, `value` is the full adresse object
// (used by the autocomplete fills).
const AdresseV2 = ({
	adresse,
	update,
	rueRef = null,
	nextRef = null,
	showExtraData = false,
}) => {
	const dispatch = useDispatch()
	const { adressesv2, localites } = useSelector((s) => s.adressesInfo)
	const numeroRef = useRef(null)
	const codePostalRef = useRef(null)
	const localiteRef = useRef(null)
	const paysRef = useRef(null)

	const onRueChange = (value) => {
		const next = { ...adresse, rue: value }
		if (value === "") next.adresse_id = null
		update("", next, true)
	}
	const onRueSelect = (ad) => {
		if (!ad) return
		update(
			"",
			{
				...adresse,
				rue: ad.rue,
				code_postal: ad.code_postal,
				localite: ad.localite,
				pays: ad.pays,
				adresse_id: ad.id,
			},
			true,
		)
		if (numeroRef.current) numeroRef.current.focus()
	}

	const onZipChange = (value) => update("code_postal", value)
	const onZipSelect = (sug) => {
		if (!sug) return
		update(
			"",
			{
				...adresse,
				code_postal: sug.zip,
				localite: sug.nom,
				pays: sug.pays,
			},
			true,
		)
		if (adresse.localite === "" && localiteRef.current)
			localiteRef.current.focus()
		else if (adresse.pays === "" && paysRef.current) paysRef.current.focus()
		else if (nextRef && nextRef.current) nextRef.current.focus()
	}
	const zipNextRef =
		adresse.localite === ""
			? localiteRef
			: adresse.pays === ""
				? paysRef
				: nextRef

	return (
		<div style={gs.fieldGroup}>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Rue</label>
				<FilteredSelectV2
					options={adressesv2}
					value={adresse.rue}
					defaultKey="rue"
					optionKeys={["rue", "code_postal"]}
					minChars={4}
					fetch={(rue) => dispatch(fetchAdressesV2({ search: rue }))}
					onChange={onRueChange}
					onSelect={onRueSelect}
					inputRef={rueRef}
					nextRef={numeroRef}
					placeholder="Rechercher une rue…"
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>N°</label>
				<input
					style={gs.input}
					ref={numeroRef}
					value={adresse.numero || ""}
					onChange={(e) => update("numero", e.target.value)}
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Code postal</label>
				<FilteredSelectV2
					options={localites}
					value={adresse.code_postal}
					defaultKey="zip"
					optionKeys={["zip", "nom"]}
					fetch={(code) => dispatch(fetchLocalites({ search: code }))}
					onChange={onZipChange}
					onSelect={onZipSelect}
					inputRef={codePostalRef}
					nextRef={zipNextRef}
					placeholder="Code postal…"
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Localité</label>
				<input
					style={gs.input}
					ref={localiteRef}
					value={adresse.localite || ""}
					onChange={(e) => update("localite", e.target.value)}
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Pays</label>
				<input
					style={gs.input}
					ref={paysRef}
					value={adresse.pays || ""}
					onChange={(e) => update("pays", e.target.value)}
				/>
			</div>
			{showExtraData && (
				<>
					<div style={gs.fieldRow}>
						<label style={gs.label}>Code porte</label>
						<input
							style={gs.input}
							value={(adresse.extra_data || {}).code_porte || ""}
							onChange={(e) =>
								update("extra_data", {
									...(adresse.extra_data || {}),
									code_porte: e.target.value,
								})
							}
						/>
					</div>
					<div style={gs.fieldRow}>
						<label style={gs.label}>Horaires</label>
						<input
							style={gs.input}
							value={(adresse.extra_data || {}).horaires || ""}
							onChange={(e) =>
								update("extra_data", {
									...(adresse.extra_data || {}),
									horaires: e.target.value,
								})
							}
						/>
					</div>
					<div style={gs.fieldRow}>
						<label style={gs.label}>Remarques</label>
						<textarea
							style={{ ...gs.input, resize: "vertical" }}
							rows={2}
							value={(adresse.extra_data || {}).remarques || ""}
							onChange={(e) =>
								update("extra_data", {
									...(adresse.extra_data || {}),
									remarques: e.target.value,
								})
							}
						/>
					</div>
				</>
			)}
		</div>
	)
}

export default AdresseV2
